import { RouterProvider } from 'react-router-dom'
import { createAppRouter } from './router'

function App() {
  const router = createAppRouter()

  return <RouterProvider router={router} />
}

export default App
